import { styled } from '../../../config'
import { Text } from '../../Text'

export const FormHelperText = styled(Text, {
  fontWeight: '$medium',
  fontSize: '$12',
  paddingBottom: '6px',
  lineHeight: '20px',
  color: '$whiteA500',
  variants: {
    weight: {
      regular: { fontWeight: '$regular' }
    },
    lineHeight: {
      16: { lineHeight: '16px' }
    }
  }
})
